import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {useMediaQuery, Grid, Typography, Box} from '@material-ui/core';
import {Image, Markdown} from 'components/atoms';
import {SectionHeader} from 'components/molecules';

const useStyles = makeStyles(() => ({
    image: {
        maxWidth: 420,
    },
}));

const Story = props => {
    const {className, ...rest} = props;
    const classes = useStyles();
    
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    
    return (
       <div className={className} {...rest}>
           <Grid
              container
              justify="space-between"
              spacing={isMd ? 4 : 2}
              direction={isMd ? 'row' : 'column-reverse'}
           >
               <Grid
                  item
                  container
                  alignItems="center"
                  justify="flex-start"
                  xs={12}
                  md={6}
                  data-aos={'fade-up'}
               >
                   <div>
                       <SectionHeader
                          title="Our story"
                          subtitle={
                              <Box display={'flex'} flexDirection={"column"}>
                                  <Typography component="div" variant={'subtitle1'}>Our founders are experts in ASC 606.
                                      More importantly, they are experts on automating complex accounting standards. We
                                      came together in 2019 with the simple mission of automating revenue recognition.
                                      In addition to this automation, we wanted to empower the accountant with their own
                                      application and “source of truth” for detailed revenue calculations. We wanted to
                                      rid them of the spreadsheets that causes inefficiencies and errors. With RevLock,
                                      you can accomplish this goal.
                                  </Typography>
                                  <br/>
                                  <Typography component="div" variant={'subtitle1'}>
                                      But <em>REVLOCK</em> goes beyond just ASC 606 or IFRS 15 compliance. This is about
                                      “knowing your revenue” and accountants being able to scale for their high-growth
                                      businesses. No longer will accountants be playing catch-up in processing revenue.
                                      RevLock empowers accountants to comply, to scale, and to provide valuable
                                      insights in the revenue of the company.
                                  </Typography>
                              </Box>
                          }
                          align="left"
                          disableGutter
                          subtitleProps={{
                              color: 'textPrimary',
                              variant: 'body1',
                          }}
                       />
                   </div>
               </Grid>
               <Grid
                  item
                  container
                  justify={isMd ? 'flex-end' : 'flex-start'}
                  alignItems="center"
                  xs={12}
                  md={6}
                  data-aos={'fade-up'}
               >
                   <Image
                      src="https://s3.amazonaws.com/content.rev-lock.com/images/work_together.svg"
                      alt="Our story"
                      className={classes.image}
                   />
               </Grid>
           </Grid>
       </div>
    );
};

Story.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Story;
